function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, HTMLAttributes } from 'react';
import { ProductInformer } from './ProductInformer';
export const ProductInformerSeo = ({
  link,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(ProductInformer, _extends({
    iconName: "drug",
    iconColor: "#8168F0",
    link: link
  }, rest), "\u0412\u0441\u0435 \u0444\u043E\u0440\u043C\u044B \u0432\u044B\u043F\u0443\u0441\u043A\u0430");
};